import { useIntl } from 'react-intl';

import { StagedChangesPill } from '@verantos-dev/shared-ui-components';

import { AnalysisRevertModal } from './AnalysisRevertModal';
import { AnalysisSaveModal } from './AnalysisSaveModal';
import { useAnalysisStagedChangesPill } from '../hooks/useAnalysisStagedChangesPill';

export const AnalysisStagedChangesPill = () => {
  const { formatMessage } = useIntl();
  const {
    visible,
    isSaveOpen,
    isRevertOpen,
    onSaveClick,
    onRevertClick,
    onCloseSave,
    onCloseRevert,
  } = useAnalysisStagedChangesPill();

  // Component stays mounted regardless of `visible` — modal mounts live at the
  // same level. Hiding the pill chrome on revert/save success must NOT take
  // the modals down with it, otherwise the modal's onClose timer is cancelled
  // and the open-flag never clears.
  return (
    <>
      <StagedChangesPill
        visible={visible}
        // Anchored to the detail page (position: relative) and draggable, so the
        // user can move it aside — matches the cohort builder's pill.
        position="absolute"
        draggable
        message={formatMessage({ id: 'analysisDetail.stagedChanges.unsaved' })}
        secondaryButton={{
          label: formatMessage({ id: 'analysisDetail.stagedChanges.revert' }),
          onClick: onRevertClick,
          'data-testid': 'analysis-staged-changes-revert',
        }}
        primaryButton={{
          label: formatMessage({ id: 'analysisDetail.stagedChanges.save' }),
          onClick: onSaveClick,
          'data-testid': 'analysis-staged-changes-save',
        }}
        data-testid="analysis-staged-changes-pill"
      />
      {isSaveOpen && <AnalysisSaveModal onClose={onCloseSave} />}
      {isRevertOpen && <AnalysisRevertModal onClose={onCloseRevert} />}
    </>
  );
};
